import { FC } from "react";
import { useDispatch, useSelector } from "../../../../../hooks";
import { upgradeBusinessesChar } from "../../../../../redux/businesses/upgrade-business-char.handler";
import { setUserExp } from "../../../../../redux/user";
import { BusinessCharType, IBusinessChar } from "../../../../../redux/businesses";
import { BalanceErrorType, useBalanceError } from "../../../../../hooks/error";
import { setUserBalanceAndLog } from "../../../../../redux/user/set-user-balance-and-log.handler";
import styles from "./BusinessCharCard.module.scss";
import currencyWhiteIcon from "../../../../../icons/currency-white.png";
import { formatNumberWithSpaces } from "../../../../../utils/numbers";
import { Highlightable } from "../../../../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../../../../hooks/prompts";

export const charData = {
    area: {
        name: 'Площадь',
        unit: 'м²'
    },
    '1': {
        name: 'Площадь',
        unit: 'м²'
    },
    staff: {
        name: 'Персонал',
        unit: 'чел.'
    },
    '2': {
        name: 'Персонал',
        unit: 'чел.'
    }
}

interface IBusinessCharCardProps extends IBusinessChar {
    type: BusinessCharType;
    icon: string;
}

export const BusinessCharCard: FC<IBusinessCharCardProps> = ({ cost, currentValue, nextValue, type, icon }) => {
    const dispatch = useDispatch();
    const business = useSelector(store => store.businesses.activeBusiness);
    const balance = useSelector(store => store.user.info.balance);
    const balanceError = useBalanceError();

    const isUpgradable = () => cost > 0;

    const getButtonCaption = () => {
        if (!isUpgradable())
            return 'Максимум';

        return (
            <>
                <span>{`+${nextValue - currentValue} ${charData[type].unit}`}</span>
                <span className={styles.upgradeCoinBlock}>
                    за <img className={styles.coinSmallIcon} src={currencyWhiteIcon} alt="price" /> { formatNumberWithSpaces(cost) }
                </span>
            </>
        );
    }

    const getValueCaption = () => `${currentValue} ${charData[type].unit}`;

    const onUpgradeHandler = async () => {
        if (!isUpgradable() || !business)
            return;

        if (balance < cost) {
            const error = type === BusinessCharType.Area ? BalanceErrorType.BusinessAreaCharUpgrade : BalanceErrorType.BusinessStaffCharUpgrade
            balanceError(cost, error);
            return;
        }

        const resultAction = await dispatch(upgradeBusinessesChar({
            businessType: business.type,
            char: type
        }));

        if (upgradeBusinessesChar.fulfilled.match(resultAction)) {            
            if (!resultAction.payload)
                return;

            const { balance, exp } = resultAction.payload;
            if (balance !== undefined)
                dispatch(setUserBalanceAndLog(balance));

            if (exp !== undefined)
                dispatch(setUserExp(exp));
        }
    }
    
    return (
        <div className={styles.charBlock}>
            <img src={ icon } alt={ charData[type].name } className={styles[`${BusinessCharType[type].toLocaleLowerCase()}Icon`]} />

            <div className={styles.charInfo}>
                <span className={styles.charLabel}>{ charData[type].name }</span>
                <span className={styles.charValue}>{ getValueCaption() }</span>
            </div>

            <Highlightable promptType={ActionPromptType.UPGRADE_BUSINESS_FIRST_TIME} highlightClass={ styles.highlight } >
                <button
                    onClick={ onUpgradeHandler }
                    className={ isUpgradable() ? styles.upgradeButton : styles.maxButton }
                >
                    { getButtonCaption() }
                </button>
            </Highlightable>
        </div>
    );
}